import React, { Component } from 'react';

export default class SearchSerialResultsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false
    };
  }

  componentDidMount() {
    this.setState({ showDialog: this.props.showDialog });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showDialog !== this.props.showDialog) {
      this.setState({ showDialog: this.props.showDialog });
    }
  }

  closeDialog = (event) => {
    event && event.preventDefault();
    this.setState({ showDialog: false });
    this.props.handleDialog && this.props.handleDialog(false);
  };

  renderResultsTable = () => {
    const { results } = this.props;

    if (!results) return null;

    if (!results.length) {
      return <p className="bold mt-3">No results found</p>;
    }

    return (
      <table className="dataTable fullWidth mt-3">
        <thead>
          <tr>
            <th>Product</th>
            <th>Serial</th>
            <th>CSO</th>
            <th>Invoice Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {results.map((row, index) => (
            <tr key={index}>
              <td>{row.ordered_ITEM || row.attribute1}</td>
              <td>{row.fm_SERIAL_NUMBER}</td>
              <td>{row.order_NUMBER}</td>
              <td>
                {row.invoice_DATE
                  ? new Date(row.invoice_DATE).toLocaleDateString()
                  : ''}
              </td>
              <td>
                <button
                  className="blueButton"
                  onClick={() => this.props.onSelect(row)}
                >
                  SELECT
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    const { showDialog } = this.state;

    return (
      <div className={"overlayDialog " + (showDialog ? "visible" : "hide")}>
        <div className="blackoutLayer"></div>

        <div className="overlayDialogWindow" style={{ width: '50em', top: 122 }}>
          <a className="closeButton" onClick={this.closeDialog}>×</a>
          <div className="dialogContent">
            {this.renderResultsTable()}
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/searchSerialResultDialog.js